import React from "react";
import PropTypes from "prop-types";
import radium from "radium";
import settings from "rizzo-next/sass/settings.json";
import Bookmark from "../bookmark";
import Bullet from "../decoration/bullet";
import Placeholder from "../placeholder";
import { rgb } from "../../utils/color";
import { poiTypes } from "../../../../../server/lib/open-planet/poiTypes";

const styles = {
  container: {
    base: {
      width: "100%",
    },
  },

  anchor: {
    base: {
      display: "flex",
      position: "relative",
    },
  },

  image: {
    base: {
      display: "block",
      height: "auto",
      float: "left",
      marginRight: settings.layout.gutter,
      width: "8rem",
    },

    placeholder: {
      float: "left",
      marginRight: settings.layout.gutter,
    },
  },

  content: {
    base: {
      alignSelf: "center",
      float: "left",
    },
  },

  details: {
    base: {
      color: `rgba(${rgb(settings.color.text)}, .5)`,
      fontSize: "1.1rem",
      lineHeight: 1,
      marginTop: ".7rem",
      textTransform: "uppercase",
    },

    item: {
      display: "inline-block",
    },
  },

  heading: {
    base: {
      color: settings.color.darkGray,
      fontSize: "1.4rem",
      fontWeight: 400,
      lineHeight: 1,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
};

/**
 * Nearby map content module
 */
function Place({ title, slug, type, category, image, bookmark, coords, distanceToNearby }) {
  return (
    <div
      className="Place clearfix"
      style={styles.container.base}
      data-type={type}
      data-lat={coords.lat}
      data-long={coords.long}
    >
      <a
        style={styles.anchor.base}
        href={`${slug}`}
      >
        {image &&
          <img
            className="Place-image"
            style={styles.image.base}
            src={image}
            alt=""
          />
        }

        {!image &&
          <Placeholder
            title={title}
            width={80}
            height={54}
            fontSize={26}
            style={styles.image.placeholder}
          />
        }

        <div
          className="Place-content"
          style={styles.content.base}
        >
          <h3
            className="Place-heading"
            style={styles.heading.base}
          >
            {title}
          </h3>

          <ul
            className="Place-details"
            style={styles.details.base}
          >
            <li style={styles.details.item}>
              {poiTypes[category].displayName}
            </li>

            {distanceToNearby &&
              <li style={styles.details.item}>
                <Bullet space="both" />
                {distanceToNearby}
              </li>
            }
          </ul>
        </div>
      </a>

      {bookmark &&
        <Bookmark
          size="small"
          center="vertical"
          align="right"
          onClick={null}
        />
      }
    </div>
  );
}

Place.propTypes = {
  title: PropTypes.string.isRequired,

  slug: PropTypes.string.isRequired,

  type: PropTypes.oneOf([
    "",
    "nearby",
    "top",
    "sight",
    "mapSidebar",
    "mapMarker",
  ]),

  category: PropTypes.string,

  image: PropTypes.string,

  bookmark: PropTypes.bool,

  coords: PropTypes.array,

  distanceToNearby: PropTypes.string,
};

Place.defaultProps = {
  type: "",

  title: "",

  slug: "",

  category: "",

  image: "",

  bookmark: false,

  coords: [],

  distanceToNearby: "",
};

Place.styles = styles;

export default radium(Place);


// WEBPACK FOOTER //
// ./assets/pois/components/place/index.jsx